module.exports = __webpack_public_path__ + "assets/images/outfit-02.585439dce6d4fc271c9e78ed5f053169.svg";